import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import request from '../../../helpers/request';

const getWorkersList = async (serviceCompanyId) => {
  let url = `/Docs/responsible_workers`;

  if (serviceCompanyId) {
    url += `?serviceCompanyId=${serviceCompanyId}`;
  }

  return await request.get(
    url,
    null,
    'Произошла ошибка при загрузке ответственных'
  );
};

export const useWorkersListQuery = (
  { serviceCompanyId } = {},
  options = {}
) => {
  return useQuery(
    queryKeys.workersList(serviceCompanyId),
    () => getWorkersList(serviceCompanyId),
    options
  );
};

export default useWorkersListQuery;
